import React from 'react';

import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IToastCloseButtonProps {
    closeToast: () => void;
}

export const ToastCloseButton = ({closeToast}: IToastCloseButtonProps) => (
    <FontAwesomeIcon icon={faTimes} onClick={closeToast} className="wficon-lg Toastify__close-button"/>
);